import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _regenerator from "@babel/runtime/helpers/esm/regenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import pushTokenService from "@/services/push-token";
import clienteService from "@/services/cliente";
import environment from "@/assets/js/environment";
var state = {
  dialogPush: false,
  dialogWhatsapp: false,
  jaRespondeu: false
};
var mutations = {
  setDialogPush: function setDialogPush(state, estado) {
    state.dialogPush = estado;
  },
  setDialogWhatsapp: function setDialogWhatsapp(state, estado) {
    state.dialogWhatsapp = estado;
  },
  setJaRespondeu: function setJaRespondeu(state, valor) {
    state.jaRespondeu = valor;
  }
};
var actions = {
  showDialogPush: function showDialogPush(_ref, estado) {
    var commit = _ref.commit,
      state = _ref.state;
    if (estado && state.jaRespondeu) return;
    commit('setDialogPush', estado);
  },
  showDialogWhatsapp: function showDialogWhatsapp(_ref2, estado) {
    var commit = _ref2.commit,
      state = _ref2.state;
    if (estado && state.jaRespondeu) return;
    commit('setDialogWhatsapp', estado);
  },
  cadastrarToken: function cadastrarToken(_ref3, identificador) {
    var _arguments = arguments;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var commit, rootGetters, possuiPush, suportaNotificacoes, messaging, token, cliente, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref3.commit, rootGetters = _ref3.rootGetters;
            possuiPush = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : false;
            if (!possuiPush) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            _context.n = 2;
            return isSupported();
          case 2:
            suportaNotificacoes = _context.v;
            if (!(suportaNotificacoes && !possuiPush)) {
              _context.n = 10;
              break;
            }
            _context.p = 3;
            messaging = getMessaging();
            _context.n = 4;
            return getToken(messaging, {
              vapidKey: environment.firebaseVapidKey
            });
          case 4:
            token = _context.v;
            console.debug("Token: ".concat(token));
            _context.p = 5;
            _context.n = 6;
            return pushTokenService.salvar({
              identificador: identificador,
              token: token
            });
          case 6:
            cliente = rootGetters['auth/cliente'];
            commit('auth/setCliente', _objectSpread(_objectSpread({}, cliente), {}, {
              tem_push: true
            }), {
              root: true
            });
            _context.n = 8;
            break;
          case 7:
            _context.p = 7;
            _t = _context.v;
            console.error(_t);
            throw new Error(_t);
          case 8:
            _context.n = 10;
            break;
          case 9:
            _context.p = 9;
            _t2 = _context.v;
            console.error("Não foi possível pegar o token", _t2);
            throw new Error(_t2);
          case 10:
            return _context.a(2);
        }
      }, _callee, null, [[5, 7], [3, 9]]);
    }))();
  },
  cadastrarEmail: function cadastrarEmail(_ref4, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _t3;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _objectDestructuringEmpty(_ref4);
            _context2.p = 1;
            _context2.n = 2;
            return clienteService.cadastrarEmail(payload);
          case 2:
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t3 = _context2.v;
            console.error(_t3);
            throw new Error(_t3);
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    }))();
  },
  cadastrarSms: function cadastrarSms(_ref5, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _t4;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _objectDestructuringEmpty(_ref5);
            _context3.p = 1;
            _context3.n = 2;
            return clienteService.cadastrarSms(payload);
          case 2:
            _context3.n = 4;
            break;
          case 3:
            _context3.p = 3;
            _t4 = _context3.v;
            console.error(_t4);
            throw new Error(_t4);
          case 4:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 3]]);
    }))();
  },
  cadastrarLigacao: function cadastrarLigacao(_ref6, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var _t5;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            _objectDestructuringEmpty(_ref6);
            _context4.p = 1;
            _context4.n = 2;
            return clienteService.cadastrarLigacao(payload);
          case 2:
            _context4.n = 4;
            break;
          case 3:
            _context4.p = 3;
            _t5 = _context4.v;
            console.error(_t5);
            throw new Error(_t5);
          case 4:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 3]]);
    }))();
  },
  cadastrarWhatsapp: function cadastrarWhatsapp(_ref7, _ref8) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var commit, rootGetters, _ref9, payload, _ref9$, possuiWhatsapp, cliente, _t6;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref7.commit, rootGetters = _ref7.rootGetters;
            _ref9 = _slicedToArray(_ref8, 2), payload = _ref9[0], _ref9$ = _ref9[1], possuiWhatsapp = _ref9$ === void 0 ? false : _ref9$;
            if (!possuiWhatsapp) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            _context5.p = 1;
            _context5.n = 2;
            return clienteService.cadastrarWhatsapp(payload);
          case 2:
            cliente = rootGetters['auth/cliente'];
            commit('auth/setCliente', _objectSpread(_objectSpread({}, cliente), {}, {
              tem_whatsapp: true
            }), {
              root: true
            });
            _context5.n = 4;
            break;
          case 3:
            _context5.p = 3;
            _t6 = _context5.v;
            console.error(_t6);
            throw new Error(_t6);
          case 4:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 3]]);
    }))();
  }
};
var getters = {
  dialogPush: function dialogPush(state) {
    return state.dialogPush;
  },
  dialogWhatsapp: function dialogWhatsapp(state) {
    return state.dialogWhatsapp;
  },
  jaRespondeu: function jaRespondeu(state) {
    return state.jaRespondeu;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};